/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Modal, StepController } from "trux"
import { useHistory } from "react-router"
import { StepReview } from "./StepReview"
import { StepSaving } from "./StepSaving"
import { filterEventsWithPlaylist } from "../../util/playlistStore"
import "./RemoveGoal.css"

export const RemoveGoal = (props) => {
    const history = useHistory()

    //// General
    const team = useSelector((state) => state.team.value)
    const game = useSelector((state) => state.game.value)
    const user = useSelector((state) => state.user.value)
    const token = useSelector((state) => state.token?.value)

    // eslint-disable-next-line no-unused-vars
    const rev = useSelector((state) => state.rev)
    let [step, setStep] = useState("review")
    // eslint-disable-next-line no-unused-vars
    let [fudge, setFudge] = useState("off_Touch")

    const moment = useSelector((state) => {
        return state.video.value.source
    })

    //// Effects

    useEffect(() => {
        document.dispatchEvent(new CustomEvent("trc-pause"))
    })

    //// Times

    let start = 0
    let end = moment ? moment.dynamic.duration : 10
    let momentStart = moment ? moment.full_game_time : 0
    let [currentTime, setCurrentTime] = useState(0)

    const onVideoUpdate = (time) => {
        setCurrentTime(time)
    }

    const close = (e) => {
        if (props.onClose) {
            props.onClose(history)
            return
        }
        let res = window.confirm("Are you sure you want to close?")
        if (res) {
            props.history.replace(
                props.location.pathname.replace(/\/do.*$/gi, "")
            )
        }
    }

    //// Review

    let reviewLocation = "none"
    if (moment && moment.meta) {
        reviewLocation = moment.meta.thirds[0]
        if (moment.meta.thirds[0] !== moment.meta.thirds[1]) {
            reviewLocation += " " + moment.meta.thirds[1]
        }
    }

    let reviewPlayers = ""
    if (game && game.home_team && moment) {
        for (let player of game.home_team.players) {
            for (let tn of moment.meta.trace_numbers) {
                if (tn === player.trace_number) {
                    let pre = reviewPlayers.length > 0 ? ", " : ""
                    reviewPlayers +=
                        pre +
                        player.user.first_name +
                        " " +
                        player.user.last_name
                }
            }
        }
    }

    let playlistText = ""
    let includedInPlaylists = []
    let sample = {}
    if (moment) {
        sample = JSON.parse(JSON.stringify(moment))
        sample.meta.type = moment.meta.type.replace("key", "")
    }
    if (game && game.playlists) {
        for (let playlist of game.playlists) {
            let prefix = playlistText.length === 0 ? "" : ", "
            let events = filterEventsWithPlaylist(playlist, [sample])
            if (playlist.enabled !== false && events.length > 0) {
                playlistText += prefix + playlist.title
                includedInPlaylists.push(playlist)
            }
        }
    }

    const postCreate = async () => {
        //let url = 'http://0.0.0.0:3000/dev/clips/remove-goal'
        let url = `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/clips/remove-goal`
        let params = {
            game_clip_id: moment.game_clip_id,
            user_id: user.user_id,
            token: token,
        }

        fetch(url, {
            method: "POST",
            body: JSON.stringify(params),
            mode: "cors",
        })
            .then((resp) => {
                return resp.json()
            })
            .then((json) => {
                if (json.error) {
                    alert(json.error)
                    setStep("review")
                } else {
                    let url = `/${team.name}/games/${game.game_id}/goals/0`
                    window.location.hash = "#" + url
                    window.location.reload()
                }
            })
    }

    //// UI requirements

    if (!moment) {
        return null
    }
    if (!game) {
        return null
    }

    return (
        <Modal
            trkContext="Editor Remove Goal"
            className={`RemoveGoal step-${step}`}
            open={true}
        >
            <StepController step={step}>
                <StepReview
                    editorType="RemoveGoal"
                    name="review"
                    title="Remove goal"
                    close={close}
                    moment={moment}
                    team={team}
                    game={game}
                    start={start}
                    end={end}
                    currentTime={currentTime}
                    momentStart={momentStart}
                    onVideoUpdate={onVideoUpdate}
                    reviewLocation={reviewLocation}
                    playlistText={playlistText}
                    reviewPlayers={reviewPlayers}
                    onBack={null}
                    nextText="Confirm remove goal"
                    onNext={(e) => {
                        postCreate()
                        setStep("saving")
                    }}
                />

                <StepSaving name="saving" title="Updating moment" />
            </StepController>
        </Modal>
    )
}
